export const questionsJavaScript = {
  English: [
    {
      question: "Which function outputs a message to the console?",
      answers: [
        { answer: "print()", correct: false, id: 1 },
        { answer: "display()", correct: false, id: 2 },
        { answer: "show()", correct: false, id: 3 },
        { answer: "console.log()", correct: true, id: 4 },
      ],
      score: 2,
    },
    {
      question: "How do you create an array in JavaScript?",
      answers: [
        { answer: "let arr = [];", correct: true, id: 1 },
        { answer: "array arr = [];", correct: false, id: 2 },
        { answer: "let arr = array[];", correct: false, id: 3 },
        { answer: "let arr = new[];", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Which built-in function converts a string to a number?",
      answers: [
        { answer: "toNumber()", correct: false, id: 1 },
        { answer: "parseInt()", correct: true, id: 2 },
        { answer: "convert()", correct: false, id: 3 },
        { answer: "Numbers()", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Which operator compares both value and data type?",
      answers: [
        { answer: "==", correct: false, id: 1 },
        { answer: "++", correct: false, id: 2 },
        { answer: "===", correct: true, id: 3 },
        { answer: "+=", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "What is the loop called that runs at least once?",
      answers: [
        { answer: "for", correct: false, id: 1 },
        { answer: "while", correct: false, id: 2 },
        { answer: "foreach", correct: false, id: 3 },
        { answer: "do...while", correct: true, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Which function is used for exception handling?",
      answers: [
        { answer: "exception()", correct: false, id: 1 },
        { answer: "try...catch", correct: true, id: 2 },
        { answer: "error()", correct: false, id: 3 },
        { answer: "alert()", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "How do you get an element by its ID?",
      answers: [
        { answer: "getById()", correct: false, id: 1 },
        { answer: "find()", correct: false, id: 2 },
        { answer: "queryId()", correct: false, id: 3 },
        { answer: "document.getElementById()", correct: true, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Which data type is for boolean values?",
      answers: [
        { answer: "string", correct: false, id: 1 },
        { answer: "integer", correct: false, id: 2 },
        { answer: "boolean", correct: true, id: 3 },
        { answer: "char", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "How to create an object in JavaScript?",
      answers: [
        { answer: "let obj = new Object()", correct: true, id: 1 },
        { answer: "let obj = [];", correct: false, id: 2 },
        { answer: "let obj = new Array();", correct: false, id: 3 },
        { answer: "let obj = {};", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Which function converts an object into a JSON string?",
      answers: [
        { answer: "toJSON()", correct: false, id: 1 },
        { answer: "parseJSON()", correct: false, id: 2 },
        { answer: "toJS()", correct: false, id: 3 },
        { answer: "JSON.stringify()", correct: true, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Which keyword is used to declare a function?",
      answers: [
        { answer: "make", correct: false, id: 1 },
        { answer: "func", correct: false, id: 2 },
        { answer: "function", correct: true, id: 3 },
        { answer: "define", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "How do you properly declare a variable?",
      answers: [
        { answer: "va name;", correct: false, id: 1 },
        { answer: "name -> var;", correct: false, id: 2 },
        { answer: "let name;", correct: true, id: 3 },
        { answer: "name = var;", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "How to call a function?",
      answers: [
        { answer: "call myFunction;", correct: false, id: 1 },
        { answer: "myFunction;", correct: false, id: 2 },
        { answer: "myFunction call;", correct: false, id: 3 },
        { answer: "myFunction();", correct: true, id: 4 },
      ],
      score: 2,
    },
    {
      question:
        "Which array method adds a new element to the beginning of the array?",
      answers: [
        { answer: "push()", correct: false, id: 1 },
        { answer: "add()", correct: false, id: 2 },
        { answer: "shift()", correct: false, id: 3 },
        { answer: "unshift()", correct: true, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Which method removes the last element from the array?",
      answers: [
        { answer: "pop()", correct: true, id: 1 },
        { answer: "remove()", correct: false, id: 2 },
        { answer: "shift()", correct: false, id: 3 },
        { answer: "delete()", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Which object is used to work with dates?",
      answers: [
        { answer: "Date()", correct: true, id: 1 },
        { answer: "Day()", correct: false, id: 2 },
        { answer: "DateTime()", correct: false, id: 3 },
        { answer: "Time()", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Which function breaks the execution of a loop?",
      answers: [
        { answer: "stop()", correct: false, id: 1 },
        { answer: "break;", correct: true, id: 2 },
        { answer: "exit()", correct: false, id: 3 },
        { answer: "return;", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question: "Which keyword is used to declare a class?",
      answers: [
        { answer: "object", correct: false, id: 1 },
        { answer: "prototype", correct: false, id: 2 },
        { answer: "class", correct: true, id: 3 },
        { answer: "struct", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question:
        "Which method is used to execute a function after a specified delay?",
      answers: [
        { answer: "delay()", correct: false, id: 1 },
        { answer: "setInterval()", correct: false, id: 2 },
        { answer: "setTimeout()", correct: true, id: 3 },
        { answer: "wait()", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question: "Which function allows making deep copies of objects?",
      answers: [
        { answer: "copy()", correct: false, id: 1 },
        { answer: "Object.assign()", correct: false, id: 2 },
        { answer: "JSON.parse(JSON.stringify(obj))", correct: true, id: 3 },
        { answer: "clone()", correct: false, id: 4 },
      ],
      score: 4,
    },
    {
      question: "What is 'this' in the context of an object method?",
      answers: [
        { answer: "Reference to the global object", correct: false, id: 1 },
        { answer: "Reference to the function", correct: false, id: 2 },
        { answer: "Reference to the current object", correct: true, id: 3 },
        { answer: "Variable with an object", correct: false, id: 4 },
      ],
      score: 4,
    },
    {
      question: "How to stop the execution of setInterval?",
      answers: [
        { answer: "stopInterval()", correct: false, id: 1 },
        { answer: "clearInterval()", correct: true, id: 2 },
        { answer: "pauseInterval()", correct: false, id: 3 },
        { answer: "breakInterval()", correct: false, id: 4 },
      ],
      score: 4,
    },
    {
      question: "What does 'NaN' stand for?",
      answers: [
        { answer: "Not a Name", correct: false, id: 1 },
        { answer: "No and No", correct: false, id: 2 },
        { answer: "Number as Negative", correct: false, id: 3 },
        { answer: "Not a Number", correct: true, id: 4 },
      ],
      score: 2,
    },
    {
      question: "How many primitive data types are in JavaScript?",
      answers: [
        { answer: "3", correct: false, id: 1 },
        { answer: "6", correct: false, id: 2 },
        { answer: "7", correct: true, id: 3 },
        { answer: "9", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Which built-in function displays an alert box?",
      answers: [
        { answer: "alert()", correct: true, id: 1 },
        { answer: "msg()", correct: false, id: 2 },
        { answer: "prompt()", correct: false, id: 3 },
        { answer: "notice()", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "How do you add comments in JavaScript?",
      answers: [
        { answer: "// Comment", correct: true, id: 1 },
        { answer: "-- Comment", correct: false, id: 2 },
        { answer: "/* Comment", correct: false, id: 3 },
        { answer: "# Comment", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Which function returns the first element of an array?",
      answers: [
        { answer: "first()", correct: false, id: 1 },
        { answer: "get(0)", correct: false, id: 2 },
        { answer: "array[0]", correct: true, id: 3 },
        { answer: "start()", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question:
        "Which function allows to round a number to the nearest whole number?",
      answers: [
        { answer: "roundNumber()", correct: false, id: 1 },
        { answer: "int()", correct: false, id: 2 },
        { answer: "round()", correct: true, id: 3 },
        { answer: "nearest()", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Which function converts a string into a number?",
      answers: [
        { answer: "toNumber()", correct: false, id: 1 },
        { answer: "parseInt()", correct: true, id: 2 },
        { answer: "convert()", correct: false, id: 3 },
        { answer: "Number()", correct: false, id: 4 },
      ],
      score: 2,
    },
  ],
  Ukrainian: [
    {
      question: "Яка функція виводить повідомлення в консоль?",
      answers: [
        { answer: "print()", correct: false, id: 1 },
        { answer: "display()", correct: false, id: 2 },
        { answer: "show()", correct: false, id: 3 },
        { answer: "console.log()", correct: true, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Як створити масив у JavaScript?",
      answers: [
        { answer: "let arr = [];", correct: true, id: 1 },
        { answer: "array arr = [];", correct: false, id: 2 },
        { answer: "let arr = array[];", correct: false, id: 3 },
        { answer: "let arr = new[];", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Яка вбудована функція перетворює рядок на число?",
      answers: [
        { answer: "toNumber()", correct: false, id: 1 },
        { answer: "parseInt()", correct: true, id: 2 },
        { answer: "convert()", correct: false, id: 3 },
        { answer: "Numbers()", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Який оператор порівнює як значення, так і тип даних?",
      answers: [
        { answer: "==", correct: false, id: 1 },
        { answer: "++", correct: false, id: 2 },
        { answer: "===", correct: true, id: 3 },
        { answer: "+=", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Який цикл називається, який виконується принаймні один раз?",
      answers: [
        { answer: "for", correct: false, id: 1 },
        { answer: "while", correct: false, id: 2 },
        { answer: "foreach", correct: false, id: 3 },
        { answer: "do...while", correct: true, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Яка функція використовується для обробки виключень?",
      answers: [
        { answer: "exception()", correct: false, id: 1 },
        { answer: "try...catch", correct: true, id: 2 },
        { answer: "error()", correct: false, id: 3 },
        { answer: "alert()", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Як ви отримати елемент за його ID?",
      answers: [
        { answer: "getById()", correct: false, id: 1 },
        { answer: "find()", correct: false, id: 2 },
        { answer: "queryId()", correct: false, id: 3 },
        { answer: "document.getElementById()", correct: true, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Який тип даних використовується для булевих значень?",
      answers: [
        { answer: "string", correct: false, id: 1 },
        { answer: "integer", correct: false, id: 2 },
        { answer: "boolean", correct: true, id: 3 },
        { answer: "char", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Як створити об'єкт у JavaScript??",
      answers: [
        { answer: "let obj = new Object()", correct: true, id: 1 },
        { answer: "let obj = [];", correct: false, id: 2 },
        { answer: "let obj = new Array();", correct: false, id: 3 },
        { answer: "let obj = {};", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Яка функція конвертує об'єкт у рядок JSON?",
      answers: [
        { answer: "toJSON()", correct: false, id: 1 },
        { answer: "parseJSON()", correct: false, id: 2 },
        { answer: "toJS()", correct: false, id: 3 },
        { answer: "JSON.stringify()", correct: true, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Яке ключове слово використовується для оголошення функції?",
      answers: [
        { answer: "make", correct: false, id: 1 },
        { answer: "func", correct: false, id: 2 },
        { answer: "function", correct: true, id: 3 },
        { answer: "define", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Як правильно оголосити змінну?",
      answers: [
        { answer: "va name;", correct: false, id: 1 },
        { answer: "name -> var;", correct: false, id: 2 },
        { answer: "let name;", correct: true, id: 3 },
        { answer: "name = var;", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Як визвати функцію?",
      answers: [
        { answer: "call myFunction;", correct: false, id: 1 },
        { answer: "myFunction;", correct: false, id: 2 },
        { answer: "myFunction call;", correct: false, id: 3 },
        { answer: "myFunction();", correct: true, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Який метод масиву додає новий елемент на початок масиву?",
      answers: [
        { answer: "push()", correct: false, id: 1 },
        { answer: "add()", correct: false, id: 2 },
        { answer: "shift()", correct: false, id: 3 },
        { answer: "unshift()", correct: true, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Який метод видаляє останній елемент з масиву?",
      answers: [
        { answer: "pop()", correct: true, id: 1 },
        { answer: "remove()", correct: false, id: 2 },
        { answer: "shift()", correct: false, id: 3 },
        { answer: "delete()", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Який об'єкт використовується для роботи з датами?",
      answers: [
        { answer: "Date()", correct: true, id: 1 },
        { answer: "Day()", correct: false, id: 2 },
        { answer: "DateTime()", correct: false, id: 3 },
        { answer: "Time()", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Яка функція припиняє виконання циклу?",
      answers: [
        { answer: "stop()", correct: false, id: 1 },
        { answer: "break;", correct: true, id: 2 },
        { answer: "exit()", correct: false, id: 3 },
        { answer: "return;", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question: "Якt ключове слово використовується для оголошення класу?",
      answers: [
        { answer: "object", correct: false, id: 1 },
        { answer: "prototype", correct: false, id: 2 },
        { answer: "class", correct: true, id: 3 },
        { answer: "struct", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question:
        "Який метод використовується для виконання функції після вказаної затримки?",
      answers: [
        { answer: "delay()", correct: false, id: 1 },
        { answer: "setInterval()", correct: false, id: 2 },
        { answer: "setTimeout()", correct: true, id: 3 },
        { answer: "wait()", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question: "Яка функція дозволяє робити глибокі копії об'єктів?",
      answers: [
        { answer: "copy()", correct: false, id: 1 },
        { answer: "Object.assign()", correct: false, id: 2 },
        { answer: "JSON.parse(JSON.stringify(obj))", correct: true, id: 3 },
        { answer: "clone()", correct: false, id: 4 },
      ],
      score: 4,
    },
    {
      question: "Що таке 'this' в контексті методу об'єкта?",
      answers: [
        { answer: "Посилання на глобальний об'єкт.", correct: false, id: 1 },
        { answer: "Посилання на поточну функцію", correct: false, id: 2 },
        { answer: "Посилання на поточний об'єкт.", correct: true, id: 3 },
        { answer: "Змінна з об'єктом.", correct: false, id: 4 },
      ],
      score: 4,
    },
    {
      question: "Як зупинити виконання setInterval?",
      answers: [
        { answer: "stopInterval()", correct: false, id: 1 },
        { answer: "clearInterval()", correct: true, id: 2 },
        { answer: "pauseInterval()", correct: false, id: 3 },
        { answer: "breakInterval()", correct: false, id: 4 },
      ],
      score: 4,
    },
    {
      question: "Що означає 'NaN'?",
      answers: [
        { answer: "Not a Name", correct: false, id: 1 },
        { answer: "No and No", correct: false, id: 2 },
        { answer: "Number as Negative", correct: false, id: 3 },
        { answer: "Not a Number", correct: true, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Скільки примітивних типів даних існує в JavaScript?",
      answers: [
        { answer: "3", correct: false, id: 1 },
        { answer: "6", correct: false, id: 2 },
        { answer: "7", correct: true, id: 3 },
        { answer: "9", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Яка вбудована функція виводить спливаюче вікно повідомлення?",
      answers: [
        { answer: "alert()", correct: true, id: 1 },
        { answer: "msg()", correct: false, id: 2 },
        { answer: "prompt()", correct: false, id: 3 },
        { answer: "notice()", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Як додавати коментарі в JavaScript?",
      answers: [
        { answer: "// Comment", correct: true, id: 1 },
        { answer: "-- Comment", correct: false, id: 2 },
        { answer: "/* Comment", correct: false, id: 3 },
        { answer: "# Comment", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Яка функція повертає перший елемент масиву?",
      answers: [
        { answer: "first()", correct: false, id: 1 },
        { answer: "get(0)", correct: false, id: 2 },
        { answer: "array[0]", correct: true, id: 3 },
        { answer: "start()", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question:
        "Яка функція дозволяє округлити число до найближчого цілого числа?",
      answers: [
        { answer: "roundNumber()", correct: false, id: 1 },
        { answer: "int()", correct: false, id: 2 },
        { answer: "round()", correct: true, id: 3 },
        { answer: "nearest()", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Яка функція перетворює рядок в число?",
      answers: [
        { answer: "toNumber()", correct: false, id: 1 },
        { answer: "parseInt()", correct: true, id: 2 },
        { answer: "convert()", correct: false, id: 3 },
        { answer: "Number()", correct: false, id: 4 },
      ],
      score: 2,
    },
  ],
  Polish: [
    {
      question: "Która funkcja wypisuje wiadomość do konsoli?",
      answers: [
        { answer: "print()", correct: false, id: 1 },
        { answer: "display()", correct: false, id: 2 },
        { answer: "show()", correct: false, id: 3 },
        { answer: "console.log()", correct: true, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Jak tworzy się tablicę w języku JavaScript?",
      answers: [
        { answer: "let arr = [];", correct: true, id: 1 },
        { answer: "array arr = [];", correct: false, id: 2 },
        { answer: "let arr = array[];", correct: false, id: 3 },
        { answer: "let arr = new[];", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Which built-in function converts a string to a number?",
      answers: [
        { answer: "toNumber()", correct: false, id: 1 },
        { answer: "parseInt()", correct: true, id: 2 },
        { answer: "convert()", correct: false, id: 3 },
        { answer: "Numbers()", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question:
        "Która wbudowana funkcja konwertuje string na liczbę w języku JavaScript?",
      answers: [
        { answer: "==", correct: false, id: 1 },
        { answer: "++", correct: false, id: 2 },
        { answer: "===", correct: true, id: 3 },
        { answer: "+=", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Która wbudowana funkcja konwertuje string na liczbę?",
      answers: [
        { answer: "for", correct: false, id: 1 },
        { answer: "while", correct: false, id: 2 },
        { answer: "foreach", correct: false, id: 3 },
        { answer: "do...while", correct: true, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Jaka jest pętla, która wykonuje się przynajmniej raz?",
      answers: [
        { answer: "exception()", correct: false, id: 1 },
        { answer: "try...catch", correct: true, id: 2 },
        { answer: "error()", correct: false, id: 3 },
        { answer: "alert()", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Jak pobrać element po jego ID",
      answers: [
        { answer: "getById()", correct: false, id: 1 },
        { answer: "find()", correct: false, id: 2 },
        { answer: "queryId()", correct: false, id: 3 },
        { answer: "document.getElementById()", correct: true, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Jaki typ danych dotyczy wartości logicznych?",
      answers: [
        { answer: "string", correct: false, id: 1 },
        { answer: "integer", correct: false, id: 2 },
        { answer: "boolean", correct: true, id: 3 },
        { answer: "char", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Jak utworzyć obiekt w JavaScript?",
      answers: [
        { answer: "let obj = new Object()", correct: true, id: 1 },
        { answer: "let obj = [];", correct: false, id: 2 },
        { answer: "let obj = new Array();", correct: false, id: 3 },
        { answer: "let obj = {};", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Która funkcja konwertuje obiekt na ciąg JSON?",
      answers: [
        { answer: "toJSON()", correct: false, id: 1 },
        { answer: "parseJSON()", correct: false, id: 2 },
        { answer: "toJS()", correct: false, id: 3 },
        { answer: "JSON.stringify()", correct: true, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Które słowo kluczowe jest używane do deklarowania funkcji",
      answers: [
        { answer: "make", correct: false, id: 1 },
        { answer: "func", correct: false, id: 2 },
        { answer: "function", correct: true, id: 3 },
        { answer: "define", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Jak poprawnie zadeklarować zmienną??",
      answers: [
        { answer: "va name;", correct: false, id: 1 },
        { answer: "name -> var;", correct: false, id: 2 },
        { answer: "let name;", correct: true, id: 3 },
        { answer: "name = var;", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Jak wywołać funkcję?",
      answers: [
        { answer: "call myFunction;", correct: false, id: 1 },
        { answer: "myFunction;", correct: false, id: 2 },
        { answer: "myFunction call;", correct: false, id: 3 },
        { answer: "myFunction();", correct: true, id: 4 },
      ],
      score: 2,
    },
    {
      question:
        "Która metoda tablicowa dodaje nowy element na początku tablicy?",
      answers: [
        { answer: "push()", correct: false, id: 1 },
        { answer: "add()", correct: false, id: 2 },
        { answer: "shift()", correct: false, id: 3 },
        { answer: "unshift()", correct: true, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Która metoda usuwa ostatni element z tablicy?",
      answers: [
        { answer: "pop()", correct: true, id: 1 },
        { answer: "remove()", correct: false, id: 2 },
        { answer: "shift()", correct: false, id: 3 },
        { answer: "delete()", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Który obiekt służy do pracy z datami?",
      answers: [
        { answer: "Date()", correct: true, id: 1 },
        { answer: "Day()", correct: false, id: 2 },
        { answer: "DateTime()", correct: false, id: 3 },
        { answer: "Time()", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Która funkcja przerywa wykonanie pętli?",
      answers: [
        { answer: "stop()", correct: false, id: 1 },
        { answer: "break;", correct: true, id: 2 },
        { answer: "exit()", correct: false, id: 3 },
        { answer: "return;", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question: "Które słowo kluczowe służy do deklarowania klasy?",
      answers: [
        { answer: "object", correct: false, id: 1 },
        { answer: "prototype", correct: false, id: 2 },
        { answer: "class", correct: true, id: 3 },
        { answer: "struct", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question:
        "Która metoda jest używana do wykonania funkcji po określonym opóźnieniu?",
      answers: [
        { answer: "delay()", correct: false, id: 1 },
        { answer: "setInterval()", correct: false, id: 2 },
        { answer: "setTimeout()", correct: true, id: 3 },
        { answer: "wait()", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question: "Która funkcja pozwala na tworzenie głębokich kopii obiektów?",
      answers: [
        { answer: "copy()", correct: false, id: 1 },
        { answer: "Object.assign()", correct: false, id: 2 },
        { answer: "JSON.parse(JSON.stringify(obj))", correct: true, id: 3 },
        { answer: "clone()", correct: false, id: 4 },
      ],
      score: 4,
    },
    {
      question: "Co to jest 'this' w kontekście metody obiektowej?",
      answers: [
        { answer: "Odniesienie do obiektu globalnego", correct: false, id: 1 },
        { answer: "Odniesienie do funkcji", correct: false, id: 2 },
        { answer: "Odniesienie do bieżącego obiektu", correct: true, id: 3 },
        { answer: "Zmienna z obiektem", correct: false, id: 4 },
      ],
      score: 4,
    },
    {
      question: "Jak zatrzymać wykonywanie setInterval?",
      answers: [
        { answer: "stopInterval()", correct: false, id: 1 },
        { answer: "clearInterval()", correct: true, id: 2 },
        { answer: "pauseInterval()", correct: false, id: 3 },
        { answer: "breakInterval()", correct: false, id: 4 },
      ],
      score: 4,
    },
    {
      question: "Co oznacza 'NaN'?",
      answers: [
        { answer: "Not a Name", correct: false, id: 1 },
        { answer: "No and No", correct: false, id: 2 },
        { answer: "Number as Negative", correct: false, id: 3 },
        { answer: "Not a Number", correct: true, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Ile prymitywnych typów danych występuje w JavaScript?",
      answers: [
        { answer: "3", correct: false, id: 1 },
        { answer: "6", correct: false, id: 2 },
        { answer: "7", correct: true, id: 3 },
        { answer: "9", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Która wbudowana funkcja wyświetla okno alertu?",
      answers: [
        { answer: "alert()", correct: true, id: 1 },
        { answer: "msg()", correct: false, id: 2 },
        { answer: "prompt()", correct: false, id: 3 },
        { answer: "notice()", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Jak dodać komentarze w JavaScript?",
      answers: [
        { answer: "// Comment", correct: true, id: 1 },
        { answer: "-- Comment", correct: false, id: 2 },
        { answer: "/* Comment", correct: false, id: 3 },
        { answer: "# Comment", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Która funkcja zwraca pierwszy element tablicy?",
      answers: [
        { answer: "first()", correct: false, id: 1 },
        { answer: "get(0)", correct: false, id: 2 },
        { answer: "array[0]", correct: true, id: 3 },
        { answer: "start()", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question:
        "Która funkcja pozwala zaokrąglić liczbę do najbliższej liczby całkowitej?",
      answers: [
        { answer: "roundNumber()", correct: false, id: 1 },
        { answer: "int()", correct: false, id: 2 },
        { answer: "round()", correct: true, id: 3 },
        { answer: "nearest()", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Która funkcja konwertuje ciąg znaków na liczbę?",
      answers: [
        { answer: "toNumber()", correct: false, id: 1 },
        { answer: "parseInt()", correct: true, id: 2 },
        { answer: "convert()", correct: false, id: 3 },
        { answer: "Number()", correct: false, id: 4 },
      ],
      score: 2,
    },
  ],
  German: [
    {
      question: "Welche Funktion gibt eine Nachricht an die Konsole aus?",
      answers: [
        { answer: "print()", correct: false, id: 1 },
        { answer: "display()", correct: false, id: 2 },
        { answer: "show()", correct: false, id: 3 },
        { answer: "console.log()", correct: true, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Wie erstellt man ein Array in JavaScript?",
      answers: [
        { answer: "let arr = [];", correct: true, id: 1 },
        { answer: "array arr = [];", correct: false, id: 2 },
        { answer: "let arr = array[];", correct: false, id: 3 },
        { answer: "let arr = new[];", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question:
        "Welche integrierte Funktion wandelt eine Zeichenfolge in eine Zahl um?",
      answers: [
        { answer: "toNumber()", correct: false, id: 1 },
        { answer: "parseInt()", correct: true, id: 2 },
        { answer: "convert()", correct: false, id: 3 },
        { answer: "Numbers()", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Welcher Operator vergleicht sowohl Wert als auch Datentyp?",
      answers: [
        { answer: "==", correct: false, id: 1 },
        { answer: "++", correct: false, id: 2 },
        { answer: "===", correct: true, id: 3 },
        { answer: "+=", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Wie heißt die Schleife, die mindestens einmal läuft?",
      answers: [
        { answer: "for", correct: false, id: 1 },
        { answer: "while", correct: false, id: 2 },
        { answer: "foreach", correct: false, id: 3 },
        { answer: "do...while", correct: true, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Welche Funktion wird zur Ausnahmebehandlung verwendet?",
      answers: [
        { answer: "exception()", correct: false, id: 1 },
        { answer: "try...catch", correct: true, id: 2 },
        { answer: "error()", correct: false, id: 3 },
        { answer: "alert()", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Wie erhält man ein Element anhand seiner ID?",
      answers: [
        { answer: "getById()", correct: false, id: 1 },
        { answer: "find()", correct: false, id: 2 },
        { answer: "queryId()", correct: false, id: 3 },
        { answer: "document.getElementById()", correct: true, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Welcher Datentyp ist für boolesche Werte?",
      answers: [
        { answer: "string", correct: false, id: 1 },
        { answer: "integer", correct: false, id: 2 },
        { answer: "boolean", correct: true, id: 3 },
        { answer: "char", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Wie erstelle ich ein Objekt in JavaScript?",
      answers: [
        { answer: "let obj = new Object()", correct: true, id: 1 },
        { answer: "let obj = [];", correct: false, id: 2 },
        { answer: "let obj = new Array();", correct: false, id: 3 },
        { answer: "let obj = {};", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Welche Funktion konvertiert ein Objekt in einen JSON-String?",
      answers: [
        { answer: "toJSON()", correct: false, id: 1 },
        { answer: "parseJSON()", correct: false, id: 2 },
        { answer: "toJS()", correct: false, id: 3 },
        { answer: "JSON.stringify()", correct: true, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Mit welchem Schlüsselwort wird eine Funktion deklariert?",
      answers: [
        { answer: "make", correct: false, id: 1 },
        { answer: "func", correct: false, id: 2 },
        { answer: "function", correct: true, id: 3 },
        { answer: "define", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Wie deklariert man eine Variable richtig?",
      answers: [
        { answer: "va name;", correct: false, id: 1 },
        { answer: "name -> var;", correct: false, id: 2 },
        { answer: "let name;", correct: true, id: 3 },
        { answer: "name = var;", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Wie rufe ich eine Funktion auf?",
      answers: [
        { answer: "call myFunction;", correct: false, id: 1 },
        { answer: "myFunction;", correct: false, id: 2 },
        { answer: "myFunction call;", correct: false, id: 3 },
        { answer: "myFunction();", correct: true, id: 4 },
      ],
      score: 2,
    },
    {
      question:
        "Welche Array-Methode fügt am Anfang des Arrays ein neues Element hinzu?",
      answers: [
        { answer: "push()", correct: false, id: 1 },
        { answer: "add()", correct: false, id: 2 },
        { answer: "shift()", correct: false, id: 3 },
        { answer: "unshift()", correct: true, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Welche Methode entfernt das letzte Element aus dem Array?",
      answers: [
        { answer: "pop()", correct: true, id: 1 },
        { answer: "remove()", correct: false, id: 2 },
        { answer: "shift()", correct: false, id: 3 },
        { answer: "delete()", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Welches Objekt wird zum Arbeiten mit Datumsangaben verwendet?",
      answers: [
        { answer: "Date()", correct: true, id: 1 },
        { answer: "Day()", correct: false, id: 2 },
        { answer: "DateTime()", correct: false, id: 3 },
        { answer: "Time()", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Welche Funktion unterbricht die Ausführung einer Schleife?",
      answers: [
        { answer: "stop()", correct: false, id: 1 },
        { answer: "break;", correct: true, id: 2 },
        { answer: "exit()", correct: false, id: 3 },
        { answer: "return;", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question: "Mit welchem Schlüsselwort wird eine Klasse deklariert?",
      answers: [
        { answer: "object", correct: false, id: 1 },
        { answer: "prototype", correct: false, id: 2 },
        { answer: "class", correct: true, id: 3 },
        { answer: "struct", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question:
        "Mit welcher Methode wird eine Funktion nach einer bestimmten Verzögerung ausgeführt?",
      answers: [
        { answer: "delay()", correct: false, id: 1 },
        { answer: "setInterval()", correct: false, id: 2 },
        { answer: "setTimeout()", correct: true, id: 3 },
        { answer: "wait()", correct: false, id: 4 },
      ],
      score: 3,
    },
    {
      question:
        "Mit welcher Funktion können tiefe Kopien von Objekten erstellt werden?",
      answers: [
        { answer: "copy()", correct: false, id: 1 },
        { answer: "Object.assign()", correct: false, id: 2 },
        { answer: "JSON.parse(JSON.stringify(obj))", correct: true, id: 3 },
        { answer: "clone()", correct: false, id: 4 },
      ],
      score: 4,
    },
    {
      question: "Was ist 'this' im Kontext einer Objektmethode?",
      answers: [
        { answer: "Referenz auf das globale Objekt", correct: false, id: 1 },
        { answer: "Verweis auf die Funktion", correct: false, id: 2 },
        { answer: "Verweis auf das aktuelle Objekt", correct: true, id: 3 },
        { answer: "Variable mit einem Objekt", correct: false, id: 4 },
      ],
      score: 4,
    },
    {
      question: "Wie kann ich die Ausführung von setInterval stoppen?",
      answers: [
        { answer: "stopInterval()", correct: false, id: 1 },
        { answer: "clearInterval()", correct: true, id: 2 },
        { answer: "pauseInterval()", correct: false, id: 3 },
        { answer: "breakInterval()", correct: false, id: 4 },
      ],
      score: 4,
    },
    {
      question: "Wofür steht 'NaN'?",
      answers: [
        { answer: "Not a Name", correct: false, id: 1 },
        { answer: "No and No", correct: false, id: 2 },
        { answer: "Number as Negative", correct: false, id: 3 },
        { answer: "Not a Number", correct: true, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Wie viele primitive Datentypen gibt es in JavaScript?",
      answers: [
        { answer: "3", correct: false, id: 1 },
        { answer: "6", correct: false, id: 2 },
        { answer: "7", correct: true, id: 3 },
        { answer: "9", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Welche integrierte Funktion zeigt eine Warnbox an?",
      answers: [
        { answer: "alert()", correct: true, id: 1 },
        { answer: "msg()", correct: false, id: 2 },
        { answer: "prompt()", correct: false, id: 3 },
        { answer: "notice()", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Wie fügt man Kommentare in JavaScript hinzu?",
      answers: [
        { answer: "// Comment", correct: true, id: 1 },
        { answer: "-- Comment", correct: false, id: 2 },
        { answer: "/* Comment", correct: false, id: 3 },
        { answer: "# Comment", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Welche Funktion gibt das erste Element eines Arrays zurück?",
      answers: [
        { answer: "first()", correct: false, id: 1 },
        { answer: "get(0)", correct: false, id: 2 },
        { answer: "array[0]", correct: true, id: 3 },
        { answer: "start()", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question:
        "Mit welcher Funktion kann eine Zahl auf die nächste ganze Zahl gerundet werden?",
      answers: [
        { answer: "roundNumber()", correct: false, id: 1 },
        { answer: "int()", correct: false, id: 2 },
        { answer: "round()", correct: true, id: 3 },
        { answer: "nearest()", correct: false, id: 4 },
      ],
      score: 2,
    },
    {
      question: "Welche Funktion wandelt einen String in eine Zahl um?",
      answers: [
        { answer: "toNumber()", correct: false, id: 1 },
        { answer: "parseInt()", correct: true, id: 2 },
        { answer: "convert()", correct: false, id: 3 },
        { answer: "Number()", correct: false, id: 4 },
      ],
      score: 2,
    },
  ],
};
